import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  private modalMap = new Map<string, BehaviorSubject<boolean>>();

  getModalState(modalId: string): Observable<boolean> {
    if (!this.modalMap.has(modalId)) {
      this.modalMap.set(modalId, new BehaviorSubject<boolean>(false));
    }
    return this.modalMap.get(modalId)!.asObservable();
  }

  openModal(modalId: string) {
    this.getModalState(modalId);
    this.modalMap.get(modalId)!.next(true);
  }

  closeModal(modalId: string) {
    if (this.modalMap.has(modalId)) {
      this.modalMap.get(modalId)!.next(false);
    }
  }
}
